/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/
// auth::api
import * as Api from './api'
// lodash - https://lodash.com/
import _ from 'lodash'

/*******************************************************************************
 * Services
 ******************************************************************************/

/*******************************************************************************
 * Configuration
 ******************************************************************************/

/*******************************************************************************
 * Transformer prototypes
 ******************************************************************************/

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/**
 * general success
 *
 * @param {obj} data
 * @return {obj} le data
 */
const _onSuccess = data => {

    if( _.get( data, 'data.data' ) ) {
        return _.get( data, 'data.data' )
    }

    return data

}

/**
 * general fail
 *
 * @param {obj} error from a server
 * @return {obj} the error
 */
const _onFailed = error => new Promise(( resolve, reject ) => {

    let error_obj = error.hasOwnProperty( 'response' ) ? error.response : error

    let return_error = {
        ...error_obj.data,
        status: error_obj.status
    }

    reject( return_error )

})

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * get the buyers associated to the current auth user
 *
 * @return {promise}
 */
export const getForUser = params =>
    Api.getForUser(params)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * create an organisation's buyer
 *
 * @return {promise}
 */
export const create = (organisation_id, data) =>
    Api.create(organisation_id, data)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * update an organisation's buyer
 *
 * @return {promise}
 */
export const updateForOrganisation = (organisation_id, buyer_id, data) =>
    Api.updateForOrganisation(organisation_id, buyer_id, data)
        .then( _onSuccess )
        .catch( _onFailed )

export const update = async (buyer_id, data) =>
    Api.update(buyer_id, data)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * get a specific organisation buyer
 *
 * @return {promise}
 */
export const showForOrganisation = (organisation_id, buyer_id) =>
    Api.showForOrganisation(organisation_id, buyer_id)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * get a specific buyer
 *
 * @return {promise}
 */
export const show = buyer_id =>
    Api.show(buyer_id)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * list for an organisation
 *
 * @return {promise}
 */
export const listForOrganisation = (organisation_id, params) =>
    Api.listForOrganisation(organisation_id, params)
        .then( _onSuccess )
        .catch( _onFailed )